export default "__VITE_ASSET__CH24fWlT__"